import { render, staticRenderFns } from "./VendorSelection.vue?vue&type=template&id=75c8ff48&"
import script from "./VendorSelection.vue?vue&type=script&lang=js&"
export * from "./VendorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports